import {
  getProVesselTypeLabel,
  getRiskLevelColor,
  ProVesselTypes,
  RiskLevel,
} from '../../../models/pro.model';

import {
  astrixFontSize,
  cellBaseStyle,
  fullWidthCellStyle,
  tableHeaderColour,
  tableHeaderTextColour,
  tableWidth,
} from '../pro-report-email-styles';

export function ProReportEmailVesselRiskTableHeader() {
  return (
    <tr
      style={{
        backgroundColor: tableHeaderColour,
        color: tableHeaderTextColour,
        fontWeight: 'bold',
      }}
    >
      <th
        style={{
          ...cellBaseStyle,
        }}
      >
        Vessel type
      </th>
      <th
        style={{
          ...cellBaseStyle,
        }}
      >
        Port claims risk*
      </th>
    </tr>
  );
}

export function ProReportEmailVesselRiskTableRow({
  vesselType,
  riskLevel,
}: {
  vesselType: ProVesselTypes;
  riskLevel: RiskLevel;
}) {
  return (
    <tr
      style={{
        fontWeight: 'bold',
      }}
    >
      <td
        style={{
          ...cellBaseStyle,
        }}
      >
        {getProVesselTypeLabel(vesselType)}
      </td>
      <td
        style={{
          ...cellBaseStyle,

          color: getRiskLevelColor(riskLevel),
        }}
      >
        {riskLevel}
      </td>
    </tr>
  );
}

function ProReportRiskTable({
  riskTableData,
}: {
  riskTableData: { vesselType: ProVesselTypes; riskLevel: RiskLevel }[];
}) {
  if (riskTableData && riskTableData.length > 0) {
    return (
      <table
        width={tableWidth}
        cellPadding={0}
        cellSpacing={0}
        style={{ borderCollapse: 'collapse', margin: 0, padding: 0 }}
        role="presentation"
      >
        <ProReportEmailVesselRiskTableHeader />
        {riskTableData.map((row) => (
          <ProReportEmailVesselRiskTableRow
            key={row.vesselType}
            vesselType={row.vesselType}
            riskLevel={row.riskLevel}
          />
        ))}
        <tfoot>
          <tr>
            <td
              colSpan={2}
              style={{
                ...fullWidthCellStyle,
                paddingLeft: 0,
                border: 'none',
              }}
            >
              <p style={{ fontSize: astrixFontSize }}>
                {`*Risk levels by vessel type are based on NorthStandard's claims experience and/or correspondents' advice as outlined below.`}
              </p>
            </td>
          </tr>
        </tfoot>
      </table>
    );
  }
  return null;
}

export default ProReportRiskTable;
